export default "__VITE_ASSET__CUj4_BAF__"